import { StationDatasetMetadata } from '@/stores/dataset/dataset-model';
import store from '@/stores/dataset/station-dataset-store';
import {
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'StationDatasetModule',
  store,
})
class StationDatasetModule extends VuexModule {
  private _metadata: StationDatasetMetadata | null = null;
  private _isLoading = false;

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get hasLoaded(): boolean {
    return this._metadata !== null;
  }

  public get metadata(): StationDatasetMetadata | null {
    return this._metadata;
  }

  @Mutation
  updateLoading(isLoading: boolean): void {
    this._isLoading = isLoading;
  }

  @Mutation
  updateMetadata(metadata: StationDatasetMetadata): void {
    this._metadata = metadata;
  }
}

export default getModule(StationDatasetModule);
